import axiosClient from '../api/AxiosConfig';

export const ConfigService = {
  GetConfig: async () => {
    return (await axiosClient.get('/config')).data;
  },
  ShowConfig: async (key, id) => {
    return (await axiosClient.patch(`/config/${key}/${id}/show`)).data;
  },
  HiddenConfig: async (key, id) => {
    return (await axiosClient.patch(`/config/${key}/${id}/hidden`)).data;
  },
  EditConfig: async (data, key, id) => {
    return (await axiosClient.put(`/config/${key}/${id}`, data)).data;
  },
  GetProvince: async () => {
    return (await axiosClient.get('/province')).data
  },
  EditProvince: async (data,id) => {
    return (await axiosClient.put(`/province/${id}`, data)).data;
  },
  CreateProvince: async (data) => {
    return (await axiosClient.post('/province', data)).data
  },
};
